import React from 'react';
import { SvgIconReact } from 'common/components/svg-icon';
import styles from './index.module.styl';
export function Cursor(_ref: {
  color: string;
  x: number;
  y: number;
  name?: string;
}) {
  let {
    color,
    x,
    y,
    name
  }: {
    color: string;
    x: number;
    y: number;
    name?: string;
  } = _ref;
  return <div className={styles.cursor} style={{
    left: x,
    top: y
  }} data-sentry-component="Cursor" data-sentry-source-file="cursor.tsx">
      <SvgIconReact icon='cursor' color={color} data-sentry-element="SvgIconReact" data-sentry-source-file="cursor.tsx" />
      {name && <div className={styles.cursorName} style={{
      backgroundColor: color
    }}>
          {name}
        </div>}
    </div>;
}